import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { updateProfile } from 'flow/actions/profile-actions';
import Page from 'flow/components/Setting/Page';
import CallRecordingSelection from 'flow/components/settings/call-recording/CallRecordingSelection';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { CallRecordingSettings, SettingsType } from 'flow/types/CallRecording';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import {
    getCallRecordingTitle,
    getUpdatedProfileDTO,
} from 'flow/utils/call-recording-monitoring-utils';
import { generatePath } from 'flow/utils/router-utils';

const ProfileCallRecordingSettingsType = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, profileKey, settingsType } = useParams<{
        extensionKey: ExtensionKey;
        profileKey: ProfileKey;
        settingsType: SettingsType;
    }>();

    const { getProfile } = useProfiles(extensionKey);
    const profile = getProfile(profileKey);

    const [storingOption, setStoringOption] = useState(null);

    if (!profile) {
        return null;
    }

    const handleOptionSelected = (value: CallRecordingSettings) => {
        setStoringOption(value);
        const profileDTO = getUpdatedProfileDTO(profile, value, settingsType);
        dispatch(
            updateProfile(extensionKey, profileDTO, () =>
                setStoringOption(null),
            ),
        );
    };

    return (
        <Page
            header={i18next.t(getCallRecordingTitle(profile))}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes[
                            'settings.profiles.profileKey.call-recording-and-monitoring'
                        ],
                        {
                            extensionKey,
                            profileKey,
                        },
                    ),
                )
            }
        >
            <CallRecordingSelection
                profile={profile}
                onSelected={handleOptionSelected}
                settingsType={settingsType}
                storingOption={storingOption}
            />
        </Page>
    );
};

export default ProfileCallRecordingSettingsType;
